// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"373":"a73a2b52","594":"60c3345e","830":"ff405d95"}[chunkId] + ".chunk.js";
};